import PortalIdParser from 'PortalIdParser';
import { initializeAuth } from './AppActions';
import { userInfoSafe } from 'hub-http/userInfo';
import isHubless from '../utils/isHubless';
import { getHublessUserInfo } from '../api/hublessApi';
export function getAuth() {
  return async dispatch => {
    PortalIdParser.get();
    const infoCall = isHubless() ? getHublessUserInfo : userInfoSafe;
    const info = await infoCall();
    return dispatch(initializeAuth(info));
  };
}